module.exports = __webpack_public_path__ + "img/points.4b72f2ce.svg";